import React, {useState} from 'react';
import {inject, observer} from 'mobx-react';
import {useNavigate, useParams} from 'react-router-dom';
import CreateFeedbackUI from '../view/CreateFeedbackUI';
import FeedbackStore from '../../store/FeedbackStore';
import ConfirmationModal from '../../../../uiToolkit/ConfirmationModal';
import ModalFade, {
  useModalFade,
} from '../../../Microreels/List/components/ModalFade';
import {
  EMPTY_FORM,
  FeedbackForm,
  hasDuplicateAnswers,
  isFormValid,
  payloadFromForm,
} from '../../feedbackForm';
import {feedbackText} from '../../feedbackText';

interface Props {
  feedbackStore?: FeedbackStore;
}

const CreateFeedbackContainer = inject('feedbackStore')(
  observer(({feedbackStore}: Props) => {
    const [form, setForm] = useState<FeedbackForm>(EMPTY_FORM);
    const [publishShown, setPublishShown] = useState(false);
    const {organizationId} = useParams();
    const navigate = useNavigate();

    const publishFade = useModalFade(publishShown);
    const listRoute = `/manage/${organizationId}/feedback_questions`;
    const isSaving = !!feedbackStore?.isEditLoading;

    const onConfirmPublish = async () => {
      if (!organizationId || !isFormValid(form)) return;
      const created = await feedbackStore!.createFeedback(
        organizationId,
        payloadFromForm(form),
      );
      setPublishShown(false);
      if (created) {
        navigate(listRoute);
      }
    };

    return (
      <>
        <CreateFeedbackUI
          form={form}
          isSaving={isSaving}
          canSave={!isSaving && isFormValid(form)}
          hasDuplicates={hasDuplicateAnswers(form.answers)}
          onChange={setForm}
          onSave={() => setPublishShown(true)}
          onCancel={() => navigate(listRoute)}
        />
        {publishFade.rendered && (
          <ModalFade closing={publishFade.closing}>
            <ConfirmationModal
              shown
              title={
                <>
                  <strong style={{display: 'block', marginBottom: '12px'}}>
                    {feedbackText.publishConfirmTitle}
                  </strong>
                  {feedbackText.publishConfirmText}
                </>
              }
              acceptText={feedbackText.publish}
              onAccept={onConfirmPublish}
              onCancel={() => setPublishShown(false)}
            />
          </ModalFade>
        )}
      </>
    );
  }),
);

export default CreateFeedbackContainer;
